import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DeviationSubjectType } from '../../../../../shared/deviations/types';
import { Deviation, InvoicingDashboardDeviationType } from '../types';

@Component({
  selector: 'dashboard-invoicing-deviations',
  templateUrl: './deviations.component.html',
  styleUrls: ['./deviations.component.scss']
})
export class DashboardInvoicingDeviationsComponent {
  @Input() deviations: Deviation[] = [];

  readonly DeviationSubjectType = DeviationSubjectType;

  constructor(private Router: Router) { }

  get visibleDeviations(): Deviation[] {
    return this.deviations.filter(deviation => deviation.count > 0);
  }

  getDescription(type: number): string {
    switch(type) {
      case InvoicingDashboardDeviationType.incompleteDrafts:
        return 'Onvolledige conceptfacturen';
      case InvoicingDashboardDeviationType.waitingForReview:
        return 'Facturen in afwachting van validatie';
      case InvoicingDashboardDeviationType.overdueInvoices:
        return 'Achterstallige facturen';
      default:
        return '';
    }
  }

  trackByType(_index: number, deviation: Deviation): number {
    return deviation.type;
  }

  showDeviations(): void {
    this.Router.navigateByUrl('invoicing');
  }
}
